
const menuData = [
  {
    id: 1,
    title: "Menu 1 – Regular",
    badge: "Best Value",
     badgeType: "value",
    description: "Ideal for small functions & budget-friendly events",
    items: [
      "Regular Sweet",
      "Steam / Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg",
      "Puri / Fulka Roti",
      "Steam Rice",
      "Dal",
      "Fryums",
      "Green Salad",
      "Butter Milk",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 229, 700: 249, 300: 299 },
    popular: false,
  },

  {
    id: 2,
    title: "Menu 2 – Standard",
     badge: "Wedding Special",
      badgeType: "wedding",
    description: "Perfect for family events & medium gatherings",
    items: [
      "Regular Soup",
      "Regular Starter",
      "Regular Sweet",
      "Steam / Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg.",
      "Puri Or Fulka Roti",
      "Dal",
      "Steam Rice",
      "Frimes",
      "Green Salad",
      "Butter Milk",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 319, 700: 339, 300: 399 },
    popular: true,
  },

  {
    id: 3,
    title: "Menu 3 – Premium",
     badge: "Premium",
    badgeType: "premium",
    description: "Best choice for weddings & premium events",
    items: [
      "WelCome Drink(Mocktail (Service Only)/Fresh Juice)",
      "Regular Soup",
      "Regular Soup",
      "Regular Starter",
      "Regular Sweet",
      "Regular Sweet",
      "Steam / Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg.",
      "Fulka Roti",
      "Puri",
      "Punjabi Dal",
      "Jeera Rice",
      "Papad",
      "Green Salad",
      "Vanila Ice Cream with Sauce",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 399, 500: 429, 300: 489 },
    popular: true,
  },

  {
    id: 4,
    title: "Menu 4 – Luxury",
    badge: "Family Special",
      badgeType: "family",
    description: "Premium menu with live counters",
    items: [
      "Welcome Drink – Mocktail (Service Only)",
      "Fresh Juice",
      "Regular Soup",
      "Premium Soup",
      "Regular Starter",
      "Live Counter (Chinese)",
      "Live Counter (Chaat)",
      "Regular Sweet",
      "Regular Liquid Sweet",
      "Steam / Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg",
      "Fulka Roti / Tandoor Roti",
      "Puri",
      "Punjabi Dal",
      "Jeera Rice",
      "Papad",
      "Green Salad",
      "Vanilla Ice Cream with Sauce",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 599, 700: 619, 300: 649 },
    popular: false,
  },

  {
    id: 5,
    title: "Menu 5 – Royal",
     badge: "Recommended",
       badgeType: "recommended",
    description: "Grand wedding & large celebration menu",
    items: [
      "Welcome Drink – Mocktail (Service Only)",
      "Fresh Juice",
      "Regular Soup",
      "Premium Soup",
      "Regular Starter",
      "Live Counter (Chinese)",
      "Live Counter (Chaat)",
      "Live Counter (South Indian)",
      "Live Counter (Baked Dish)",
      "Premium Sweet",
      "Regular Liquid Sweet",
      "Steam Farsan",
      "Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg.",
      "Premium Bread",
      "Fulka Roti",
      "Punjabi Dal",
      "Jeera Rice",
      "Variety Papad",
      "Green Salad",
      "Mix Pasta Salad",
      "Peanuts Salad",
      "Premium Ice Cream",
      "Water Bottle (On Demand – Service Only)",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 749, 700: 829, 300: 899 },
    popular: true,
  },

  {
    id: 6,
    title: "Menu 6 – Grand Elite",
      badge: "Corporate Choice",
      badgeType: "corporate",
    description: "Ultra-premium catering with multiple live counters",
    items: [
      "Welcome Drink – Mocktail (Service Only)",
      "Welcome Drink – Mocktail (Service Only)",
      "Fresh Juice",
      "Regular Soup",
      "Premium Soup",
      "Regular Starter",
      "Premium Starter",
      "Live Counter (Chinese)",
      "Live Counter (Chaat)",
      "Live Counter (South Indian)",
      "Live Counter (Fast Food)",
      "Premium Sweet",
      "Regular Liquid Sweet",
      "Steam Farsan",
      "Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg.",
      "Kathiyavadi Veg.",
      "Premium Bread",
      "Fulka Roti",
      "Punjabi Dal",
      "Jeera Rice",
      "Variety Papad",
      "Green Salad",
      "Mix Pasta Salad",
      "Peanuts Salad",
      "Premium Ice Cream",
      "Water Bottle",
      "Water Jug",
      "Mukhavas",
    ],
    prices: { 1000: 829, 700: 899, 300: 949 },
    popular: false,
  },

  {
    id: 7,
    title: "Menu 7 – Platinum",
    badge: "Popular",
     badgeType: "popular",
    description: "Exclusive destination wedding & luxury events",
    items: [
      "Mocktail Bar",
      "Fresh Juice",
      "Fresh Juice",
      "Regular Soup",
      "Premium Soup",
      "Regular Starter",
      "Premium Starter",
      "Live Counter (Chinese)",
      "Live Counter (Chaat)",
      "Live Counter (South Indian)",
      "Live Counter (Fast Food)",
      "Live Counter (Mexican)",
      "Live Counter (Baked Dish)",
      "Premium Sweet",
      "Regular Liquid Sweet",
      "Regular Sweet",
      "Steam Farsan",
      "Fry Farsan",
      "Chutney (If required)",
      "Sabji Flavours of Punjabi",
      "Seasonal Veg",
      "Kathiyawadi Veg",
      "Premium Bread",
      "Fulka Roti",
      "Puri", 
      "Bundi Raita",
      "Mix Veg Biryani",
      "Punjabi Dal",
      "Jeera Rice",
      "Variety Papad",
      "Green Salad",
      "Kathol (Pulses) Salad",
      "Chanachor Salad",
      "Vadhavani Maracha",
      "Mix Pasta Salad",
      "Peanuts Salad",
      "Ice Cream / Roll Cut Kulfi",
      "Water Bottle",
      "Water Jug",
      "Variety Mukhavas",
    ],
    prices: { 1000: 1149, 700: 1299 },
    popular: true,
  },
];

export default menuData;
